import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="animal-block"
export default class extends Controller {
  
  static targets = ["row"]

  get deceasedRows() {
    return this.rowTargets.filter(row => row.hasAttribute("data-deceased"))
  }

  get discardedRows() {
    return this.rowTargets.filter(row => row.hasAttribute("data-discarded"))
  }
  
  toggleDeceased() {

    // Determine if there are currently any hidden deceased animals
    const hasHiddenAnimals = this.deceasedRows.some(row => row.classList.contains("hidden"))
    
    // If there are then unhide all rows
    if (hasHiddenAnimals) {
      this.deceasedRows.forEach(row => row.classList.remove("hidden"))
    }

    // If there are no hidden rows then hide all deceased rows
    else {
      this.deceasedRows.forEach(row => row.classList.add("hidden"))
    }
  }

  toggleDiscarded() {
      
      // Determine if there are currently any hidden discarded animals
      const hasHiddenAnimals = this.discardedRows.some(row => row.classList.contains("hidden"))
      
      // If there are then unhide all rows
      if (hasHiddenAnimals) {
        this.discardedRows.forEach(row => row.classList.remove("hidden"))
      }
  
      // If there are no hidden rows then hide all discarded rows
      else {
        this.discardedRows.forEach(row => row.classList.add("hidden"))
      }
    }
  
}
